export const formatNumbers = (mask, number) => {
  let s = '' + number,
    r = '';
  for (let im = 0, is = 0; im < mask.length && is < s.length; im++) {
    r += mask.charAt(im) === 'X' ? s.charAt(is++) : mask.charAt(im);
  }
  return r;
};
